import React from 'react';

import Popover from '@mui/material/Popover';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { formatDateRange } from 'ff/debrief/utils';
import moment from 'moment';

interface Props {
    open: boolean;
    anchorEl: HTMLButtonElement | null;
    onClose: () => void;
    startTimestamp: number;
    endTimestamp: number;
    onStartChange: (timestamp: number) => void;
    onEndChange: (timestamp: number) => void;
}

const DateFilterPopover: React.FC<Props> = ({
    open,
    anchorEl,
    onClose,
    startTimestamp,
    endTimestamp,
    onStartChange,
    onEndChange,
}) => {
    const startDate = startTimestamp ? moment.unix(startTimestamp) : null;
    const endDate = endTimestamp ? moment.unix(endTimestamp) : null;

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        >
            <Box>
                <Box px={2} py={1}>
                    <Typography variant="h6" fontWeight={600}>
                        Date Filters
                    </Typography>
                    {startTimestamp && endTimestamp && (
                        <Typography variant="caption" color="text.secondary">
                            {formatDateRange(startTimestamp, endTimestamp)}
                        </Typography>
                    )}
                </Box>
                <Divider />
                <Box display="flex">
                    <Box p={1}>
                        <Typography
                            variant="body1"
                            fontWeight={600}
                            color="text.secondary"
                        >
                            Start Date
                        </Typography>
                        <DateCalendar
                            value={startDate}
                            onChange={date =>
                                date && onStartChange(date.unix())
                            }
                            maxDate={endDate}
                            disableFuture
                        />
                    </Box>
                    <Divider orientation="vertical" flexItem />
                    <Box p={1}>
                        <Typography
                            variant="body1"
                            fontWeight={600}
                            color="text.secondary"
                        >
                            End Date
                        </Typography>
                        <DateCalendar
                            value={endDate}
                            onChange={date => date && onEndChange(date.unix())}
                            minDate={startDate}
                            disableFuture
                        />
                    </Box>
                </Box>
            </Box>
        </Popover>
    );
};

export default DateFilterPopover;
